import styled from 'styled-components';

import { ArticleTopShoesMobile } from 'editorial/components/ArticleTopShoesMobile';
import { ArticleTopShoesDesktop } from 'editorial/components/ArticleTopShoesDesktop';
import { IArticleSectionAdditionalProps, IArticleTopShoesSection } from 'editorial/types';
import { variableFontRegular } from 'styles/theme/text';
import { useWindowSize } from 'shared/hooks/useWindowSize';

export const ArticleTopShoes = ({
  text,
  productTemplates,
}: IArticleTopShoesSection & IArticleSectionAdditionalProps) => {
  const { isMobile } = useWindowSize();

  return (
    <>
      {isMobile ? (
        <ArticleTopShoesMobile results={productTemplates} title={text} />
      ) : (
        <ArticleTopShoesDesktop title={text} productTemplates={productTemplates} />
      )}
    </>
  );
};

ArticleTopShoes.Header = styled.h3`
  text-transform: capitalize;
  font-weight: 400;
  ${variableFontRegular({ size: '36px', height: '1.22', spacing: '-0.3' })};
  padding: 70px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    ${variableFontRegular({ size: '22px', height: '22px', spacing: '-0.5px' })};
  }
`;

ArticleTopShoes.GridCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
`;

ArticleTopShoes.GridWrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(auto-fill, 50%);

  ${ArticleTopShoes.GridCell} {
    border-bottom: ${({ theme }) => theme.borders.black};
  }

  /* mobile: 2 columns */
  ${ArticleTopShoes.GridCell}:nth-child(odd) {
    border-right: ${({ theme }) => theme.borders.black};
  }

  /* tablet: 3 columns */
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    grid-template-columns: repeat(auto-fill, 33.33%);
    border-left: ${({ theme }) => theme.borders.black};

    ${ArticleTopShoes.GridCell}:nth-child(-n+3) {
      border-top: ${({ theme }) => theme.borders.black};
    }

    ${ArticleTopShoes.GridCell}:nth-child(even) {
      border-right: ${({ theme }) => theme.borders.black};
    }
  }

  /* desktop: 4 columns */
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    grid-template-columns: repeat(auto-fill, 25%);

    ${ArticleTopShoes.GridCell}:nth-child(-n+4) {
      border-top: ${({ theme }) => theme.borders.black};
    }
  }
`;

ArticleTopShoes.ProductInfo = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-column-gap: 16px;
  grid-row-gap: 6px;
  padding: 14px 16px;
  grid-template-columns: 38px auto;
  grid-template-areas: 'number name';
`;

ArticleTopShoes.Number = styled.div`
  grid-area: number;
  height: 16px;
`;

ArticleTopShoes.Name = styled.div`
  grid-area: name;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 42px;
`;
